const constants = Object.freeze({
  DEFAULT_ACCESS_TOKEN: '2a6a9daba0786ac56af562afac4d3a8a',
  DEFAULT_LOCATION: 5,
  USER_ROLE_ID: 3,
  WAITER_PRODUCT_ID: 208,
  DEFAULT_WAITER_QUANTITY: 1,
  DEFAULT_DELIVERY_METHOD: 3,
  DEFAULT_PAYMENT_METHOD: 1,
});

export default constants;
